export default {
  tas: {
    name: 'TAS',
    taxes_type: 'Generalidade',
  },
  tda: {
    name: 'TDA',
    taxes_type: 'Generalidade',
  },
  tde: {
    name: 'TDE',
    taxes_type: 'Generalidade',
  },
  trt: {
    name: 'TRT',
    taxes_type: 'Generalidade',
  },
  gris: {
    name: 'GRIS',
    taxes_type: 'Generalidade',
  },
  toll: {
    name: 'PEDAGIO',
    taxes_type: 'Generalidade',
  },
  taxes: {
    name: 'IMPOSTOS REPAS',
    taxes_type: 'Generalidade',
  },
  pickup: {
    name: 'COLETA',
    taxes_type: 'Generalidade',
  },
  suframa: {
    name: 'SUFRAMA',
    taxes_type: 'Generalidade',
  },
  base_freight_cost: {
    name: 'FRETE PESO',
    taxes_type: 'Generalidade',
  },
  invoice_percentage_cost: {
    name: 'FRETE VALOR',
    taxes_type: 'Generalidade',
  },
  icms: {
    name: 'ICMS',
    taxes_type: 'Imposto',
  },
  iss: {
    name: 'ISS',
    taxes_type: 'Imposto',
  },
  ademe: {
    name: 'ADEME',
    taxes_type: 'Generalidade',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/xml-cte-tags/enums/EnumTmsName.js